import * as signalR from '@microsoft/signalr'
import Vue from 'vue'
import { onUnmounted, ref, computed, unref, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import DashboardService from '@/services/modules/DashboardService'
import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'

export default function useRuntimeEquipeAgenteSituacaoNotifications(equipeId) {
  const { accessToken } = storeToRefs(useAuthStore())
  const { id } = storeToRefs(useUserStore())

  const url = computed(() => ({
    remote: `${process.env.VUE_APP_FLOW.replace('api/', '')}runtime-equipe-agente-situacao-hub?token=${accessToken.value}&EquipeId=${unref(equipeId)}&GestorId=${id.value}`,
    local: `https://localhost:7294/runtime-equipe-agente-situacao-hub?token=${accessToken.value}&EquipeId=${unref(equipeId)}&GestorId=${id.value}`,
  }))

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(url.value.remote, { transport: signalR.HttpTransportType.WebSockets })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.None)
    .build()

  const agentesSituacoes = ref([])
  const loading = ref(false)

  async function startConnection() {
    try {
      connection.baseUrl = url.value.remote
      await connection.start()
    } catch {
      setTimeout(startConnection, 5000)
    }
  }

  async function stopConnection() {
    if (connection.state === signalR.HubConnectionState.Disconnected) return
    await connection.stop()
  }

  connection.on('ReceiveUnauthorizedMessage', async message => {
    await stopConnection()
    Vue.$toast.warning(message)
  })

  connection.on('ReceiveSituacoesAgentes', message => {
    agentesSituacoes.value = JSON.parse(message)
  })

  async function getSituacoesDeAgentesDeUmaEquipeAsync() {
    try {
      loading.value = true
      agentesSituacoes.value = await DashboardService.getSituacoesDeAgentesDeUmaEquipeAsync(unref(equipeId))
    } finally {
      loading.value = false
    }
  }

  async function resetConnection() {
    agentesSituacoes.value = []
    await stopConnection()
    await startConnection()
    await getSituacoesDeAgentesDeUmaEquipeAsync()
  }

  onUnmounted(stopConnection)
  watchEffect(() => { if (unref(equipeId)) { resetConnection() } })

  return {
    agentesSituacoes,
    loading,
  }
}
